import { modelLabel, PART_KIND_LABEL, PART_TRANSACTION_LABEL } from '../lib/parts';
import type { Part, PartKind, PartTransactionType } from '../lib/types';
import { Badge } from './ui';

type Tone = Parameters<typeof Badge>[0]['tone'];

export function PartKindBadge({ kind }: { kind: PartKind }) {
  return <Badge tone={kind === 'REPAIR_PART' ? 'violet' : 'blue'}>{PART_KIND_LABEL[kind]}</Badge>;
}

export function StockBadge({ part }: { part: Pick<Part, 'quantityOnHand' | 'lowStock'> }) {
  if (part.quantityOnHand === 0) return <Badge tone="red">Out of stock</Badge>;
  if (part.lowStock) return <Badge tone="amber">Low · {part.quantityOnHand} left</Badge>;
  return <Badge tone="green">{part.quantityOnHand} in stock</Badge>;
}

const TRANSACTION_TONE: Record<PartTransactionType, Tone> = {
  RECEIVED: 'green',
  ASSIGNED: 'blue',
  RETURNED: 'gray',
  USED: 'violet',
  PUT_BACK: 'amber',
  ADJUSTED: 'gray',
};

export function PartTransactionBadge({ type }: { type: PartTransactionType }) {
  return <Badge tone={TRANSACTION_TONE[type]}>{PART_TRANSACTION_LABEL[type]}</Badge>;
}

/** The models a part fits, shortened to the first few. */
export function FitsList({ models, max = 2 }: { models: Part['models']; max?: number }) {
  if (models.length === 0) return <span className="text-slate-500">Any device</span>;
  return (
    <span className="text-slate-700">
      {models.slice(0, max).map(modelLabel).join(', ')}
      {models.length > max && <span className="text-slate-400"> +{models.length - max} more</span>}
    </span>
  );
}
